<template>
  <div>
    <div class="adding-panel">
      <b-button
        v-if="mayEditPlayerData"
        :to="{name: 'player_pending_add', params: {playerId: playerId}}" variant="primary"
      >
        New pending
      </b-button>
    </div>

    <loading-indicator v-if="isLoading"></loading-indicator>

    <p v-if="message !== null">
      {{message}}
    </p>
    <table v-if="isDataLoaded && pendings.length > 0" class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Time</th>
          <th scope="col">Author</th>
          <th scope="col">Type</th>
          <th scope="col">Status</th>
          <th scope="col">Info</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="pending in sortedPendings">
        <tr :key="pending.id">
          <td>{{pending.id}}</td>
          <td class="text-nowrap">{{pending.ctime | getMomentStr}}</td>
          <td>
            <user-link
              v-if="pending.userId"
              :user="getUser(pending.userId)"
            />

            <template v-if="pending.serviceId">
              {{ getPendingCreatorServiceName(pending.serviceId) }}
            </template>
          </td>
          <td>{{pending.purpose | getEnumPendingPurposeName}}</td>
          <td>{{pending.status | getEnumPendingStatusName}}</td>
          <td>
            <player-pending-info
              :pending="pending"
            />
          </td>
        </tr>
        </template>
      </tbody>
    </table>

  </div>
</template>

<script>
import auth from '../auth.js';
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';
import { mayEditPlayerData as utilMayEditPlayerData } from '../util.js';
import { convertUserArrayToMap } from '../model/user.js';
import { getUserFromMap } from '../model/user.js';
import { getPendingCreatorServiceName } from '../model/pending.js';

import { getEnumPendingPurposeName } from '../autogen/bundle.js';
import { getEnumPendingStatusName  } from '../autogen/bundle.js';

import LoadingIndicator  from './LoadingIndicator.vue';
import PlayerPendingInfo from './PlayerPendingInfo.vue';
import UserLink from './UserLink.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayerPendings',

  components: {
    LoadingIndicator,
    PlayerPendingInfo,
    UserLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      actor: auth.getViewer(),

      loadingStatus: LOADING_STATUS__INIT,

      /** @type {Object[]} */
      pendings: null,

      userMap: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {boolean} */
    isDataLoaded() {
      return this.pendings !== null;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      if(this.pendings !== null && this.pendings.length === 0) {
        return 'This player has no pendings.';
      }
      return null;
    },

    /** @returns {Object[]} */
    sortedPendings() {
      return this.pendings.slice().sort((a, b) => b.id - a.id);
    },

    /** @returns {boolean} */
    mayEditPlayerData() {
      return utilMayEditPlayerData(this.actor.role);
    },
  },

  methods: {
    getUser(userId) {
      return getUserFromMap(this.userMap, userId);
    },

    getPendingCreatorServiceName,
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.loadingStatus = LOADING_STATUS__LOADING;

    const url = `/player/${this.playerId}/pendings`;

    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.userMap = convertUserArrayToMap(data.users);
      this.pendings = data.pendings;

      this.loadingStatus = LOADING_STATUS__NORMAL;
    })
    .catch(err => {
      this.loadingStatus = LOADING_STATUS__ERROR;
      notifier.showError(err, {sender: this});
    });
  },

  filters: {
    getEnumPendingPurposeName,
    getEnumPendingStatusName,
  },
}
</script>
